import React, { useState } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import config from "../../config/default.json";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const base_url = config.base_url;
const RECAPTCHA_SITE_KEY = "6LcHoAMsAAAAAIDghi3QFf5sVnkq1jYB7NIjyOzt"; // 👈 replace this

const RegisterForm = () => {
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [captchaToken, setCaptchaToken] = useState(null);
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      setMessage("Please complete CAPTCHA verification.");
      return;
    }

    try {
      setMessage("Registering...");
      const res = await axios.post(base_url + '/api/register', {
        ...formData,
        'g-recaptcha-response': captchaToken, // send to backend
      });

      setMessage(res.data.message);
      alert(res.data.message);
      setFormData({ name: '', email: '', password: '' });
      setCaptchaToken(null);
    } catch (err) {
      alert('Error: ' + err.response?.data?.error || 'Registration failed.');
      setMessage(err.response?.data?.error || 'Registration failed');
    }
  };

  return (
    <div>
      <Link to={`/`} className="header-button">
        <FontAwesomeIcon icon={faHome} /> &nbsp; Home
      </Link>

      <h2>Register</h2>
      <section className="contact">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="input-box">
            <label>Name</label>
            <input
              type="text"
              name="name"
              className="field"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-box">
            <label>Email</label>
            <input
              type="email"
              name="email"
              className="field"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-box" style={{ position: 'relative' }}>
            <label>Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              className="field"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: 'center',
                right: '20px',
                top: '48px',
                cursor: 'pointer',
                color: '#888',
              }}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
          </div>

          {/* ✅ reCAPTCHA widget */}
          <div style={{ marginTop: '15px', marginBottom: '15px' }}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={setCaptchaToken}
            />
          </div>

          <button type="submit">Register</button>
        </form>
      </section>

      <p>{message}</p>
      <p>Already have an account?</p>
      <Link to={`/auth/login`} className="header-button">
        <FontAwesomeIcon icon={faUser} /> &nbsp; Login
      </Link>
    </div>
  );
};

export default RegisterForm;
